export const projects = [
  {
    id: 1,
    title: "Vacation Planner Back End",
    tech: "NodeJS, ExpressJS, PostgreSQL, JWT, bcryptjs, supertest",
    description: [
      "Planning vacations sucks. There is so much time and effort spent wasted on things that just simply get in the way of the fun. Vacation planner is your one stop shop for planning out that radical family vacation that you've been dreaming about all year.",
      "The project was built in a week, where I worked with 3 other frontend developers. My role as the single backend developer was to provide a RESTful API where frontend developers could register and login users, as well as provide CRUD operations for vacation plans. You can click on the demo to view the documentation for the backend.",
    ],
    github: "www.github.com/Build-Vacation-Planner/Back-End",
    demo: "vacation-planner-be.herokuapp.com/docs/",
    image: ["/Images/vp-backend.jpg"],
    maxWidth: [800],
  },
  {
    id: 2,
    title: "NBA Career Longevity Predictor Front End",
    tech: "React, Redux, React Router, axios, Material UI",
    description: [
      "NBA contracts are sometimes 9 figures long. It is in a team's best interest to have a good idea of the longevity of a player's productivity. This application uses historical data to find similar players and predict a selected player's likely longevity in the league.",
      "The application will allow you select a player from a list of current and past players. The machine learning models will predict the selected player expected longevity in the NBA league, as well as return a player that is the most similar to the player picked. Users are also able to save a player to their personal list for quick reference and edit their name.",
      "My role in this project was to implement, design and lead the frontend that would communicate with the backend and machine learning models. I also delegated tasks to two other junior frontend developers. This project was during a build week, in a remote team of 8 students.",
    ],
    login: "jd//jd",
    github: "www.github.com/Build-NBA-Career-Longevity-Predictor/front-end",
    demo: "nba-clp.netlify.com",
    image: ["/Images/react-nba.jpg"],
    maxWidth: [800],
  },
  {
    id: 3,
    title: "MyDish Mobile Application",
    tech: "React Native, React Navigation, Redux, expo, axios",
    description: [
      "A source-control cooking app built in React Native which allows users to quickly make and save a history of changes to their recipe.",
      "The application was created with the intent of having a way to digitalize the notes commonly found on the margin of your grandma's cooking notebook. A user is able to create and edit personal recipes, while also storing those recipes in their own digital cookbook that is organized by categories.",
      "This was a built-on project built with React Native in the frontend and Node/Express backend where I collaborated with a remote team of 7 full stack developers over 8 weeks. I previously had no experience with the Expo CLI and React Native, however was able to to quickly familiarize myself with the codebase and implement optimizations that reduced the amount of calls done to the backend, as well as squash some obscure bugs. While also polishing the codebase for future teams.",
    ],
    github: "www.github.com/jambis/mydish-fe",
    demo: "play.google.com/store/apps/details?id=com.lambdaschool.mydish",
    image: [
      "/Images/mydish1.jpg",
      "/Images/mydish2.jpg",
      "/Images/mydish3.jpg",
    ],
    maxWidth: [300, 300, 300],
  },
  {
    id: 4,
    title: "oneStep Maze",
    tech: "React, React Router, HTML Canvas, Django",
    description: [
      "oneStep Maze is a project that was built in a week, on a team of 5 remote full stack developers where I had to quickly learn Django over the weekend to implement a backend that could randomly generate a maze, and provide the frontend with the API to move a player through the rooms of the maze. Furthermore I also helped with the syncing of moving the character through the canvas with the backend.",
      "The frontend created with React and canvas to render the maze and knight (player), You can move with the WASD keys.",
    ],
    login: "demouser//pass12345",
    github: "www.github.com/Trying-our-best",
    image: ["/Images/onemaze.jpg"],
    maxWidth: [800],
    demo: "cs-bw1-tob.netlify.com/",
  },
];
